<template>
  <div id="app">

      <router-view name="blank"></router-view>
      <router-view></router-view>

  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
#app {
  background-color: #222d32;
}

.sl {
  min-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #909399;
}

.station {
  max-height: 400px;
  overflow-y: auto;
}

.el-table .el-table__fixed-header-wrapper th,
.el-table .el-table__header-wrapper th {
  font-size: 14px !important;
}

.el-tag {
  border-radius: 40px !important;
  font-size: 12px !important;
}

.el-radio-button:first-child .el-radio-button__inner {
  border-left: 1px solid #DCDFE6;
  border-radius: 6px 0 0 6px !important;
  box-shadow: none !important;
}

.el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 6px 6px 0 !important;
}

</style>
